export default "__VITE_ASSET__a897fd8c__"